function LinkToFile({ setMenuCollapsed, to, children }) {
  const handleClick = () => {
    if (setMenuCollapsed) setMenuCollapsed(true);
  };

  return (
    <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      {children}
    </a>
  );
}
export default LinkToFile;
